(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  const cards = document.querySelectorAll(".collection-list__item");

  function handleClick(event) {
    const card = event.target.closest('.collection-list__item');
    const button = card.querySelector('[data-button-interaction]');
    if (card) {
      const isTextSelected = window.getSelection().toString();
      if (!isTextSelected && card) {
        window.location.href = card.dataset.href;
        if(button)
          pushToDataLayer(button);
      }
    }
  };

  cards.forEach(card => {
    const cardInner = card.querySelector('.card-inner');
    const cardOverlay = card.querySelector('.card-overlay');

    if (cardInner) {
      // Handles image clicks on mobile and prevents iOS double clicking issues
      cardInner.addEventListener("click", handleClick);
    }

    if (cardOverlay) {
      // Handles desktop card clicks (hidden on mobile)
      cardOverlay.addEventListener("click", handleClick);
    }

    const sublinks = Array.from(card.querySelectorAll(".sub-link__item"));

    sublinks.forEach(sublink => {
      sublink.addEventListener("click", (e) => e.stopPropagation());
    });
  });
  
    document.querySelectorAll('.collection-list [data-button-interaction]').forEach(button => {
      button.addEventListener('click', () => pushToDataLayer(button));
    });


    function pushToDataLayer(button) {
      if(window.location.pathname == "/pages/holiday-gift-guide") {
        try {
          const interactionData = JSON.parse(button.dataset.buttonInteraction);
          dataLayer.push({
            event: "component.menu_interaction",
            interaction: interactionData
          });
        } catch (error) {
          console.log("Error parsing this button: ", button, error);
        }
      }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-service"] && !Shopify.designMode) return;
  try {
    
  const chatButtons = document.querySelectorAll(".contact-information__chat button");
  for (let i = 0; i < chatButtons.length; i++) {
    chatButtons[i].addEventListener("click", function() {
      // LiveChatWidget.call("maximize");
      openGladlyChat();
    });
  }

  const quickLinkAnchors = document.querySelectorAll('.quick-links__link a');
  for (let i = 0; i < quickLinkAnchors.length; i++) {
    if ((quickLinkAnchors[i].getAttribute('href').charAt(0) !== '#') || !document.querySelector(quickLinkAnchors[i].getAttribute('href'))) continue;
    quickLinkAnchors[i].addEventListener("click", function(e) {
      e.preventDefault();
      handleAnchorScrollTo(e);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expandable-content"] && !Shopify.designMode) return;
  try {
    
  class ExpandableContent extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.expandable-content__button');
      this.content = this.querySelector('.expandable-content__liquid');
      this.contentInner = this.content.querySelector('.expandable-content__liquid-inner');

      this.button.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      // Cancel any pending hiding transitiion
      clearTimeout(this.hideTimeoutId);

      const open = this.classList.toggle('expandable-content--open');

      this.button.ariaExpanded = open ? "true" : "false";
      this.content.ariaHidden = open ? "false" : "true";
      this.content.style.height = open ? `${this.contentInner.scrollHeight}px` : '0px';

      /* 
      *  Toggle content visibility immediately on open, but on close delay to match the 
      *  transition length before hiding, preventing the content from immediately vanishing
      *  on close.
      */
      if (open) {
        this.content.style.visibility = "visible";
      } else {
        this.hideTimeoutId = setTimeout(() => {
          this.content.style.visibility = "hidden";
        }, 500);
      }
    }
  }

  customElements.define('expandable-content', ExpandableContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-diagram-advanced"] && !Shopify.designMode) return;
  try {
    
    class FeatureSlider extends HTMLElement {
      constructor() {
        super();

        window.addEventListener('load', this.initCarousel.bind(this));

        this.contentWrapper = this.closest(".feature-diagram__inner-wrapper");
        this.featureButtons = this.contentWrapper.querySelectorAll('.feature-diagram__feature-selector');
        this.navButtons = this.contentWrapper.querySelectorAll(".feature__prev-next .flickity-button, .feature__prev-prev .flickity-button");
        this.sectionId = this.dataset.sectionId;

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:load', this.initCarousel.bind(this));
          document.addEventListener('shopify:block:select', (event) => {
            const {blockId, sectionId} = event.detail;

            if (this.dataset.sectionId === sectionId) {
              const block = this.querySelector(`#block-${blockId}`);

              if (block) {
                const index = block.dataset.index;

                if (index) {
                  this.flkty.select(parseInt(index));
                }
              }
            }
          })
        }
      }

      initCarousel() {
        this.flkty = new Flickity(this, {
          cellAlign: "left",
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          wrapAround: true,
          adaptiveHeight: false
        });

        for (let featureButton of this.featureButtons) {
          featureButton.addEventListener('click', () => {
            this.flkty.select(parseInt(featureButton.dataset.featureKey));
          })
        }

        this.flkty.on('change', (index) => {
          const currentSelector = this.contentWrapper.querySelector(`.feature-diagram__feature-selector[data-feature-key="${index}"]`);
          const featuredSlideIndexElement = this.contentWrapper.querySelector(`.current-slide-index-${
            this.sectionId
          }`);

          for (let featureButton of this.featureButtons) {
            featureButton.classList.remove('selected');
          }

          currentSelector.classList.add('selected');
          featuredSlideIndexElement.innerHTML = parseInt(index) + 1;
        });

        for (let navButton of this.navButtons) {
          navButton.addEventListener('click', () => {
            if (navButton.classList.contains('next')) {
              this.flkty.next();
            } else {
              this.flkty.previous();
            }
          })
        }
      }
    }

    customElements.define('feature-slider', FeatureSlider);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-diagram"] && !Shopify.designMode) return;
  try {
    
  class FeatureSlider extends HTMLElement {
    constructor() {
      super();

      window.addEventListener('load', this.initCarousel.bind(this));

      this.contentWrapper = this.closest(".feature-diagram__inner-wrapper");
      this.featureButtons =  this.contentWrapper.querySelectorAll('.feature-diagram__feature-selector');
      this.navButtons = this.contentWrapper.querySelectorAll(".feature__prev-next .flickity-button, .feature__prev-prev .flickity-button");
      this.sectionId = this.dataset.sectionId;

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.initCarousel.bind(this));
        document.addEventListener('shopify:block:select', (event) => {
          const { blockId, sectionId } = event.detail;

          if (this.dataset.sectionId === sectionId) {
            const block = this.querySelector(`#block-${blockId}`);

            if (block) {
              const index = block.dataset.index;

              if (index) {
                this.flkty.select(parseInt(index));
              }
            }
          }
        })
      }
    }

    initCarousel() {
      this.flkty = new Flickity(this, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        adaptiveHeight: false
      });

      for (let featureButton of this.featureButtons) {
        featureButton.addEventListener('click', () => {
          this.flkty.select(parseInt(featureButton.dataset.featureKey));
        })
      }

      this.flkty.on('change', (index) => {
        const currentSelector = this.contentWrapper.querySelector(`.feature-diagram__feature-selector[data-feature-key="${index}"]`);
        const featuredSlideIndexElement = this.contentWrapper.querySelector(`.current-slide-index-${this.sectionId}`);

        for (let featureButton of this.featureButtons) { 
          featureButton.classList.remove('selected');
        } 
 
        currentSelector.classList.add('selected');
        featuredSlideIndexElement.innerHTML = parseInt(index) + 1;
      });

      for (let navButton of this.navButtons) {
        navButton.addEventListener('click', () => {
          if (navButton.classList.contains('next')) {
            this.flkty.next();
          } else {
            this.flkty.previous();
          }
        })
      }
    }
  }

  customElements.define('feature-slider', FeatureSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    

  KlaviyoSubscribe.attachToForms('#email_signup', {
    hide_form_on_success: true,
    extra_properties: {
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      $consent_version: 'Embed default text'
    }
  });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('scroll', this.fadeBetweenLogos);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    fadeBetweenLogos() {
      const checkpoint = 200;
      const currentScroll = window.pageYOffset;
      let opacity = 0;
      let logo = document.querySelector(".header__heading-logo.large-up-hide");
      let logoMobile = document.querySelector(".header__heading-logo__mobile");

      if (logoMobile) {
        // Show desktop logo
        if (currentScroll <= checkpoint) {
          opacity = 1 - currentScroll / checkpoint;
        } else {
          opacity = 0;
        }

        if (logo) logo.style.opacity = opacity;

        // Show mobile logo
        if (currentScroll >= checkpoint) {
          opacity = 1.5 - checkpoint / currentScroll;
        } else {
          opacity = 0;
        }

        if (logoMobile) logoMobile.style.opacity = opacity;
      } else {
        // Only display desktop logo
        opacity = 1;
        if (logo) logo.style.opacity = opacity;
      }

    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.activeMediaIndex = -1;
      this.mediaItems = [];
      this.mediaThumbnails = [];
      this.pointerStart = null;

      this.addEventListener('keydown', this.onKeyDown.bind(this));
      this.addEventListener('pointerup', this.onModalPointerUpCapture.bind(this), true);
      this.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.addEventListener('pointerup', this.onPointerUp.bind(this));
    }

    hide() {
      // Prevent focusing on the opener when closing to avoid triggering navigation
      const opener = this.openedBy;

      this.openedBy = null;
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      if (this.announcementBar) this.announcementBar.classList.remove('hide-header');
      if (this.header) this.header.classList.remove('hide-header');

      removeTrapFocus();
      window.pauseAllMedia();

      this.openedBy = opener;
    }

    show(opener) {
      super.show(opener);
      this.initializeMediaItems();
      this.initializeMediaThumbnails();
      this.showActiveMedia();
    }

    initializeMediaItems() {
      this.mediaItems = Array.from(this.querySelectorAll('[role="document"] [data-media-id]'));
    }

    initializeMediaThumbnails() {
      this.mediaThumbnails = Array.from(this.querySelectorAll('[data-modal-media-thumb]'));
      this.mediaThumbnails.forEach((thumbnail) => {
        if (thumbnail.dataset.boundClick === 'true') return;
        thumbnail.addEventListener('click', () => {
          const mediaId = thumbnail.getAttribute('data-media-id');
          const targetMedia = this.mediaItems.find((item) => item.getAttribute('data-media-id') === mediaId);
          if (!targetMedia) return;
          this.activeMediaIndex = this.mediaItems.findIndex((item) => item === targetMedia);
          this.setActiveMedia(targetMedia);
        });
        thumbnail.dataset.boundClick = 'true';
      });
    }

    onKeyDown(event) {
      if (!this.hasAttribute('open')) return;
      if (event.code === 'ArrowLeft') {
        event.preventDefault();
        this.navigateToMedia(-1);
      } else if (event.code === 'ArrowRight') {
        event.preventDefault();
        this.navigateToMedia(1);
      }
    }

    onModalPointerUpCapture(event) {
      if (event.pointerType !== 'mouse') return;
      if (event.target.closest('.product-media-modal__dialog')) {
        event.stopPropagation();
      }
    }

    onPointerDown(event) {
      if (!this.hasAttribute('open')) return;
      this.pointerStart = { x: event.clientX, y: event.clientY };
    }

    onPointerUp(event) {
      if (!this.hasAttribute('open') || !this.pointerStart) return;

      const deltaX = event.clientX - this.pointerStart.x;
      const deltaY = event.clientY - this.pointerStart.y;
      this.pointerStart = null;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
      this.navigateToMedia(deltaX < 0 ? 1 : -1);
    }

    navigateToMedia(step) {
      if (!this.mediaItems.length || this.activeMediaIndex < 0) return;
      const itemCount = this.mediaItems.length;
      const nextIndex = (this.activeMediaIndex + step + itemCount) % itemCount;
      const nextMedia = this.mediaItems[nextIndex];
      if (!nextMedia) return;

      this.activeMediaIndex = nextIndex;
      this.setActiveMedia(nextMedia);
    }

    setActiveMedia(activeMedia) {
      if (!activeMedia) return;

      this.mediaItems.forEach((element) => {
        element.classList.remove('active');
      });

      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      this.setActiveThumbnail(activeMedia.getAttribute('data-media-id'));

      const container = this.querySelector('[role="document"]');
      if (!container) return;

      container.scrollLeft = 0;

      requestAnimationFrame(() => {
        const scrollPosition = activeMedia.offsetLeft - (container.clientWidth / 2) + (activeMedia.offsetWidth / 2);
        container.scrollLeft = Math.max(0, scrollPosition);
      });

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      const isMobile = window.innerWidth <= 749 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (activeMedia.nodeName !== 'DEFERRED-MEDIA') return;

      const hasExternalVideo = activeMediaContent && (activeMediaContent.querySelector('.js-youtube') || activeMediaContent.querySelector('.js-vimeo'));
      const hasRegularVideo = activeMediaContent && activeMediaContent.querySelector('video');
      if (!hasExternalVideo && !hasRegularVideo) return;

      activeMedia.loadContent();

      if (!hasRegularVideo) return;

      const checkVideo = setInterval(() => {
        const video = activeMedia.querySelector('video');
        if (!video) return;

        clearInterval(checkVideo);
        if (isMobile) {
          video.autoplay = true;
          if (video.paused) {
            video.play().catch(() => {});
          }
        } else {
          video.autoplay = false;
          if (!video.paused) video.pause();
        }
      }, 50);

      setTimeout(() => clearInterval(checkVideo), 2000);
    }

    setActiveThumbnail(mediaId) {
      if (!this.mediaThumbnails.length) return;
      this.mediaThumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.getAttribute('data-media-id') === mediaId;
        thumbnail.classList.toggle('is-active', isActive);
        if (isActive) {
          thumbnail.setAttribute('aria-current', 'true');
          thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumbnail.removeAttribute('aria-current');
        }
      });
    }

    showActiveMedia() {
      const openedMediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
      const activeMedia = openedMediaId
        ? this.querySelector(`[role="document"] [data-media-id="${openedMediaId}"]`)
        : this.mediaItems[0];
      if (!activeMedia) return;

      this.activeMediaIndex = this.mediaItems.findIndex((item) => item === activeMedia);
      this.setActiveMedia(activeMedia);
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class ProductItem extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', this.openHref.bind(this));
      this.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          const isTextSelected = window.getSelection().toString();
          if (!isTextSelected && this) {
            window.location.href = this.dataset.href;
          }
        }
      });
    }

    openHref() {
      const isTextSelected = window.getSelection().toString();
      if (!isTextSelected && this) {
        window.location.href = this.dataset.href;
      }
    }
  }

  customElements.define('product-item', ProductItem);

  class ProductListMobile extends HTMLElement {
    constructor() {
      super();

      window.addEventListener('DOMContentLoaded', this.addCarousel.bind(this));

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.addCarousel.bind(this));
        document.addEventListener('shopify:block:select', (event) => {
          const { blockId, sectionId } = event.detail;

          if (this.dataset.sectionId === sectionId) {
            const block = this.querySelector(`#block-${blockId}`);

            if (block) {
              const index = block.dataset.index;

              if (index) {
                this.flkty.select(parseInt(index));
              }
            }
          }
        })
      }
    }

    addCarousel() {
      this.flkty = new Flickity( this, {
        wrapAround: false,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: true,
        cellAlign: 'left'
      });
    }
  }

  customElements.define('product-list-mobile', ProductListMobile);

  document.addEventListener('DOMContentLoaded', function() {
  const productContainers = document.querySelectorAll('.product-list__container');

  if (productContainers.length > 0) {
    let observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const visibleProducts = [];
          const products = entry.target.querySelectorAll('.product-list__product');
          const currencyCode = products[0].getAttribute('data-item-currency');
          
          products.forEach(function(product, index) {
            const itemId = product.getAttribute('data-item-id');
            const itemSku = product.getAttribute('data-item-sku');
            const itemName = product.getAttribute('data-item-name');
            const itemBrand = product.getAttribute('data-item-brand');
            const itemCategory = product.getAttribute('data-item-category');
            const itemListName = window.location.pathname;
            const itemVariants = product.getAttribute('data-item-variants');
            const price = product.getAttribute('data-price');
            const quantity = 1;
            const itemCategory2 = product.getAttribute('data-item-category2'); 
            const itemCategory3 = product.getAttribute('data-item-category3'); 
            const itemCategory4 = product.getAttribute('data-item-category4'); 
            const itemCategory5 = product.getAttribute('data-item-category5'); 
            const itemBadge = product.getAttribute('data-item-badge');
            const itemAge = product.getAttribute('data-item-age');
            const itemGender = product.getAttribute('data-item-gender');
            const discount = product.getAttribute('data-item-discount');

            productObj = {
              item_id: itemId,
              item_sku: itemSku,
              item_name: itemName,
              item_brand: itemBrand,
              item_category: itemCategory,
              item_list_name: itemListName,
              item_variant: itemVariants,
              price: price,
              quantity: quantity,
              index: index,
              item_category2: itemCategory2,
              item_category3: itemCategory3,
              item_category4: itemCategory4,
              item_category5: itemCategory5,
              item_badge: itemBadge,
              item_age: itemAge,
              item_gender: itemGender,
              discount: discount
            };

            for (const key in productObj) {
              if (productObj[key] === null || productObj[key] === "") {
                delete productObj[key];
              }
            }

            visibleProducts.push(productObj);
          });

          

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'dl_view_item_list',
            ecommerce: {
              currency: currencyCode,
              items: visibleProducts,
              item_list_name: window.location.pathname
            },   
          });

          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    productContainers.forEach(function(container) {
      observer.observe(container);
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  class SpecList extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.specifications__expand');
      this.buttonWrapper = this.querySelector('.specifications__expand-wrapper');
      this.collapsedContent = this.querySelector('.specifications__hidden-wrapper');
      this.collapsedContentInner = this.querySelector('.specifications__hidden');

      if (this.dataset.blockCount == 0) {
        this.populateContent();
      } else if(!this.dataset.hasBlocksWithContent) {
        this.hideSection();
      }

      this.button.addEventListener("click", this.toggle.bind(this));
    }

    toggle() {
      // Cancel any pending hiding transitiion
      clearTimeout(this.hideTimeoutId);

      const open = this.classList.toggle('specifications--expanded'); 

      this.button.ariaExpanded = open ? "true" : "false";
      this.collapsedContent.ariaHidden = open ? "false" : "true";
      this.collapsedContent.style.height = open ? `${this.collapsedContentInner.scrollHeight}px` : '0px';

      /*
      *  Toggle content visibility immediately on open, but on close delay to match the
      *  transition length before hiding, preventing the content from immediately vanishing
      *  on close.
      */
      if (open) {
        this.collapsedContentInner.style.visibility = "visible";
      } else {
        this.hideTimeoutId = setTimeout(() => {
          this.collapsedContentInner.style.visibility = "hidden";
        }, 500);
      }
    }

    hideSection() {
      this.closest('.shopify-section').style.display = 'none';
    }

    parseSpecContent(value, depth = 0) {
      let newVal = '';

      // Try to make nested object and array values not look stupid
      if (Array.isArray(value)) {
        newVal = value.map(v => this.parseSpecContent(v, depth + 1)).join(", ");
      } else if (typeof value === "object" && value !== null) {
        const keys = Object.keys(value);

        keys.forEach((key, index) => {
          const indent = '    ';
          const lineStart = indent.repeat(depth);  // indent nested object key-value pairs
          let keySeparator = key.includes(':') ? '' : ':';
          keySeparator += depth > 0 ? ' ' : '\n';

          newVal += `${lineStart}${key}${keySeparator}${this.parseSpecContent(value[key], depth + 1)}${index < keys.length - 1 ? '\n' : ''}`;
        })
      } else {  
        newVal = value;
      }

      return newVal;
    }

    populateContent() {
      this.visibleContent = this.querySelector('.specifications__visible');
      this.hiddenContent = this.querySelector('.specifications__hidden');

      const script = this.querySelector("[type='application/json']");

      if (!script) {
        this.hideSection();
        return;
      }

      try {
        const data = JSON.parse(script.textContent);

        // Hide entire section if no specs available for product
        if (!data || Object.keys(data).length == 0) {
          this.hideSection()
          return;
        }

        // Populate the visible and hidden spec content areas
        Object.keys(data).forEach((key, i) => {
          const row = document.createElement('div');
          row.setAttribute('class', 'specifications__spec-row');

          const dt = row.appendChild(document.createElement('dt'));
          dt.setAttribute('class', 'specifications__spec-label h5');
          dt.textContent = key;

          const dd = row.appendChild(document.createElement('dd'));
          dd.setAttribute('class', 'specifications__spec-description h5-regular');
          dd.textContent = this.parseSpecContent(data[key]);

          if (i < this.dataset.visibleCount) {
            this.visibleContent.append(row);
          } else {
            this.hiddenContent.append(row);
            this.buttonWrapper.classList.remove('hidden');
          }
        })
      } catch (e) {
        console.error("Error parsing spec json: ", e);
        this.hideSection();
      }
    }
  }

  customElements.define('spec-list', SpecList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-image"] && !Shopify.designMode) return;
  try {
    
  const leftSplits = document.querySelectorAll(".split-image__left-split");
  const rightSplits = document.querySelectorAll(".split-image__right-split");
  const leftSplitsMobile = document.querySelectorAll(".mobile-split__left");
  const rightSplitsMobile = document.querySelectorAll(".mobile-split__right");

  function handleClickLeft(event) {
    const leftSplit = event.target.closest('.split-image__left-split');
    const isTextSelected = window.getSelection().toString();
    if (!isTextSelected && leftSplit) {
      window.location.href = leftSplit.dataset.href;
    }
  };

  function handleClickRight(event) {
    const rightSplit = event.target.closest('.split-image__right-split');
    const isTextSelected = window.getSelection().toString();
    if (!isTextSelected && rightSplit) {
      window.location.href = rightSplit.dataset.href;
    }
  };

  function handleClickLeftMobile(event) {
    const leftSplit = event.target.closest('.mobile-split__left');
    const isTextSelected = window.getSelection().toString();
    if (!isTextSelected && leftSplit) {
      window.location.href = leftSplit.dataset.href;
    }
  };

  function handleClickRightMobile(event) {
    const rightSplit = event.target.closest('.mobile-split__right');
    const isTextSelected = window.getSelection().toString();
    if (!isTextSelected && rightSplit) {
      window.location.href = rightSplit.dataset.href;
    }
  };

  leftSplits.forEach(split => {
    split.addEventListener("click", handleClickLeft);
  });

  rightSplits.forEach(split => {
    split.addEventListener("click", handleClickRight);
  });

  leftSplitsMobile.forEach(split => {
    split.addEventListener("click", handleClickLeftMobile);
  });

  rightSplitsMobile.forEach(split => {
    split.addEventListener("click", handleClickRightMobile);
  });


  } catch(e) { console.error(e); }
})();
})();
